import Axios from '@/assets/js/AxiosPlugin'
// 会员统计
export const memberByMonth = params => {
  return Axios.post('/api/Admin/Statistics/memberByMonth', params)
}



// WEBPACK FOOTER //
// ./src/views/webpc/MemberStatistics/overviewApp/apis/index.js